var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "vue-account-wrapper" }, [
    _c(
      "div",
      {
        staticClass:
          "d-flex align-items-center justify-content-between p-2 rounded clickable-account-pill",
        attrs: { "data-toggle": "modal", "data-target": "#infoModal" }
      },
      [
        _c(
          "div",
          { staticClass: "d-flex align-items-center overflow-hidden" },
          [
            _c("i", { staticClass: "text-secondary fas fa-building mr-2" }),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass:
                  "text-secondary small font-weight-bold text-truncate",
                staticStyle: { "max-width": "100px" }
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.currentAccountName) +
                    "\n            "
                )
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c("i", {
          staticClass: "fas fa-chevron-right text-muted",
          staticStyle: { "font-size": "0.7rem" }
        })
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "modal fade",
        attrs: { id: "infoModal", tabindex: "-1", role: "dialog" }
      },
      [
        _c(
          "div",
          { staticClass: "modal-dialog modal-lg", attrs: { role: "document" } },
          [
            _c("div", { staticClass: "modal-content rounded" }, [
              _c(
                "div",
                {
                  staticClass:
                    "modal-header d-flex flex-column align-items-start border-bottom-0 pb-0"
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex w-100 justify-content-between align-items-center"
                    },
                    [
                      _c("div", { staticClass: "d-flex align-items-center" }, [
                        _vm._m(0),
                        _vm._v(" "),
                        _c("div", [
                          _c(
                            "div",
                            { staticClass: "text-secondary small mt-1" },
                            [
                              _c("i", { staticClass: "fas fa-building mr-1" }),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "text-uppercase font-weight-bold",
                                  staticStyle: {
                                    "letter-spacing": "0.5px",
                                    "font-size": "0.7rem"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(_vm.currentAccountName) +
                                      "\n                    "
                                  )
                                ]
                              )
                            ]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _vm._m(1)
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "modal-body" },
                [_c("accountselector")],
                1
              )
            ])
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "div",
      { staticClass: "bg-light rounded p-2 mr-3 text-primary" },
      [_c("i", { staticClass: "fas fa-exchange-alt" })]
    )
  },
  function() {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "button",
      {
        staticClass: "close ml-auto",
        staticStyle: { outline: "none" },
        attrs: {
          type: "button",
          "data-dismiss": "modal",
          "aria-label": "Close"
        }
      },
      [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }